import { useMemo } from 'react'

import { useUser } from 'src/providers/UserProvider'

import { useGetAccountAndPlanterRegistrationQuery } from 'src/config/generated/graphql'
import { ApplicationWorkflowState } from 'src/types/application'

export const useHasPlanterExperience = () => {
  const { user } = useUser()
  const {
    data: accountData,
    loading: experienceDataLoading,
    called: experienceDataCalled
  } = useGetAccountAndPlanterRegistrationQuery({
    variables: {
      id: user?.ActiveAccountId
    }
  })

  const planterExperience = useMemo(
    () => accountData?.Account_by_pk?.Planter?.PlanterRegistrations[0] || null,
    [accountData]
  )

  const hasPlanterExperience = useMemo(
    () =>
      !!planterExperience ||
      accountData?.Account_by_pk?.Planter?.Projects.some(p =>
        p.Applications.some(a =>
          [
            ApplicationWorkflowState.Approved,
            ApplicationWorkflowState.Planted,
            ApplicationWorkflowState.Monitoring
          ].includes(a.WorkflowState as ApplicationWorkflowState)
        )
      ) ||
      false,
    [accountData, planterExperience]
  )

  return {
    planterExperience,
    hasPlanterExperience,
    experienceDataLoading,
    experienceDataCalled
  }
}
